module.exports = __webpack_public_path__ + "img/borderRingWhite.378db628.svg";